module.exports = __webpack_public_path__ + "img/server.47426fe4.webp";